import { ArrowLeft, CalendarDays, Share2 } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import { toSafeHtml } from "../lib/content";
import { PublicPageSkeleton } from "../components/LoadingSkeleton";

export function NewsDetailPage() {
  const { slug } = useParams();
  const { news, loading } = useContent();
  const post = news.find((item) => item.slug === slug);

  if (loading) return <PublicPageSkeleton variant="article" />;
  if (!post) return <div className="not-found"><span>404</span><h1>Beitrag nicht gefunden</h1><Link className="button button--dark" to="/aktuelles">Zurück zu Aktuelles</Link></div>;

  const formattedDate = new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "long", year: "numeric" }).format(new Date(post.published_at));
  const share = async () => {
    if (navigator.share) await navigator.share({ title: post.title, url: window.location.href });
    else await navigator.clipboard.writeText(window.location.href);
  };

  return (
    <article className="article-page">
      <div className="article-top page-width">
        <Link to="/aktuelles" className="back-link"><ArrowLeft size={17} /> Alle Beiträge</Link>
        <div className="article-meta"><span><CalendarDays size={16} /> {formattedDate}</span><button onClick={() => void share()}><Share2 size={16} /> Teilen</button></div>
        <h1>{post.title}</h1>
      </div>
      {post.cover_image && <div className="article-cover page-width"><img src={post.cover_image} alt="" /></div>}
      <div className="article-content" dangerouslySetInnerHTML={{ __html: toSafeHtml(post.body) }} />
      {post.images.length > 0 && <div className="article-gallery page-width">{post.images.map((image) => <img key={image} src={image.startsWith("/") ? image : `/${image}`} alt="Impression zum Beitrag" loading="lazy" />)}</div>}
      <div className="article-footer page-width"><Link className="text-link text-link--large" to="/aktuelles"><ArrowLeft size={18} /> Mehr Vereinsnews</Link></div>
    </article>
  );
}
